import { alpha } from '@mui/material';
import { BASE_COLORS, GREY } from './palette.base';

export function paletteFactory(mode = 'light') {
    const isLight = mode === 'light';

    return {
        mode,

        ...BASE_COLORS,

        common: { black: '#000', white: '#fff' },

        text: {
            primary: isLight ? GREY[800] : GREY[100],
            secondary: isLight ? GREY[600] : GREY[400],
            disabled: GREY[500],
        },

        background: {
            paper: isLight ? '#fff' : GREY[800],
            default: isLight ? '#fff' : GREY[900],
            neutral: isLight ? GREY[200] : GREY[700],
        },

        divider: alpha(GREY[500], 0.24),

        action: {
            active: GREY[600],
            hover: alpha(GREY[500], 0.08),
            selected: alpha(GREY[500], 0.16),
            disabled: alpha(GREY[500], 0.8),
            disabledBackground: alpha(GREY[500], 0.24),
            focus: alpha(GREY[500], 0.24),
            hoverOpacity: 0.08,
            disabledOpacity: 0.48,
        },
    };
}
